import { Routes } from '@angular/router';

export const INSIGHTS_ROUTES: Routes = [
	{
		path: 'campaigns/:id',
		loadComponent: () => import('./campaign/report/report.component').then((m) => m.InsightsCampaignComponent),
		data: {
			features: ['insights.campaigns'],
			hidden: true,
		},
	},
	{
		path: 'campaigns',
		loadComponent: () =>
			import('./campaign/dashboard/campaign-dashboard.component').then((m) => m.InsightsCampaignDashboardComponent),
		data: {
			features: ['insights.campaigns'],
			'mobile-unsupported': true,
		},
	},
	{
		path: 'revenue',
		loadComponent: () => import('./revenue/revenue.component').then((m) => m.InsightsRevenueComponent),
		data: {
			features: ['insights.revenue'],
			'mobile-unsupported': true,
		},
	},
	{
		path: 'tickets',
		loadComponent: () => import('./tickets/tickets.component').then((m) => m.InsightsTicketsComponent),
		data: {
			features: ['insights.tickets'],
			'mobile-unsupported': true,
		},
	},
	{
		path: 'performance',
		loadComponent: () => import('./performance/performance.component').then((m) => m.InsightsPerformanceComponent),
		data: {
			features: ['insights.performance'],
			'mobile-unsupported': true,
		},
	},
	{
		path: 'sustainability',
		loadComponent: () =>
			import('./sustainability/sustainability.component').then((m) => m.InsightsSustainabilityComponent),
		data: {
			features: ['insights.sustainability'],
			'mobile-unsupported': true,
		},
	},
	{
		path: 'compliance',
		loadComponent: () => import('./compliance/compliance.component').then((m) => m.InsightsComplianceComponent),
		data: {
			features: ['insights.compliance'],
			'mobile-unsupported': true,
		},
	},
];
